// Import reusable components
import { Spinner } from "@/components/ui/Spinner";
import EmptyStateCard from "@/components/ui/EmptyStateCard";
import OrderDetailsHeader from "./components/OrderDetailsHeader";
import OrderStatusAlert from "./components/OrderStatusAlert";
import OrderProductSection from "./components/OrderProductSection";
import OrderNotesSection from "./components/OrderNotesSection";
import OrderCustomerInfo from "./components/OrderCustomerInfo";
import OrderPaymentSection from "./components/OrderPaymentSection";

// Import utils and helpers
import { OrderDetailsProvider, useOrderDetailsContext } from "./context/OrderDetailsContext";

function OrderDetailsContent() {
  const { order, isLoading, isError, refetch, isNewOrder } = useOrderDetailsContext();

  if (isNewOrder) {
    return (
      <div className="flex flex-col gap-4 px-6 pt-6">
        <EmptyStateCard
          title="New order flow"
          description="Order creation is not yet implemented."
        />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 px-6 pt-12">
        <Spinner size="medium" />
        <p className="text-sm text-[#4b4b4b]">Loading order details...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="px-6 pt-6">
        <EmptyStateCard
          title="Failed to load order"
          description="Please try refreshing the page or check your connection."
          buttonLabel="Retry"
          onAction={refetch}
        />
      </div>
    );
  }

  if (!order) {
    return (
      <div className="px-6 pt-6">
        <EmptyStateCard
          title="Order not found"
          description="We could not locate this order. It may have been removed."
          buttonLabel="Go back"
          onAction={() => window.history.back()}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 px-6 pt-6">
      <OrderDetailsHeader />
      <OrderStatusAlert />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-2 pb-[2em]">
          <OrderProductSection />
          <OrderPaymentSection />
        </div>

        <div className="space-y-6">
          <OrderNotesSection />
          <OrderCustomerInfo />
        </div>
      </div>
    </div>
  );
}

export default function OrderDetails() {
  return (
    <OrderDetailsProvider>
      <OrderDetailsContent/>
    </OrderDetailsProvider>
  );
}
